import React, { useEffect } from 'react'
import { Content, RightSide, StructureContainer, Title, ButtonDiv, Button, StructureHeader, AllowFilesDiv } from '../CreateCertificate/style'
import ManageStructures from './ManageStructures'
import ParamMainFields from './ParamMainFields'
import { ColumnType } from '../../../../components/Modals/EditStructure'
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'
import { CertificateOutletType } from '..'
import StructureColumns from './StructureColumns'
import saveImage from '../../../../assets/certificates/AddParameter/save.svg'
import axios from '../../../../config/axios'
import { SwitchBox, SwitchInput, SwitchSlider } from '../../Accesses/ProfilesTable/style'

export interface StructureType {
  id: number
  name: string
  columns: ColumnType[]
}

export interface ParamType {
  id?: number
  structures: StructureType[]
  type?: {id:number, name:string}
  name?: string
  class?: string
  family?: string
  astm?: string
  uns?: string
  din?: string
  aisi?: string
  others?: string
}

const CreateParam = () => {
  const { setParam, param, setLoading } = useOutletContext<CertificateOutletType>()
  const [ searchParams ] = useSearchParams()
  const navigate = useNavigate()
  const id = searchParams.get('id')
  const duplicateFrom = searchParams.get('duplicateFrom')
  
  useEffect(() => {
    const sourceId = id || duplicateFrom
    if(sourceId) {
      setLoading(true)
      axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/${sourceId}`)
        .then(response => {
          if(response.data) {
            if (duplicateFrom && !id) {
              const { id: _sourceId, ...rest } = response.data
              setParam({
                ...rest,
                name: `${rest.name || ''} - cópia`.replace(/^\s+/, ''),
              })
            } else {
              setParam(response.data)
            }
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])
  
  const handleCreateOrEditParam = () => {
    const {id, type, ...data} = param
    setLoading(true)
    if(id) {
      axios.put(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/${id}`, {...data, certificateTypeId: type?.id})
        .then(() => {
          navigate('..')
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          setLoading(false)
        })
      return
    }
    axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/`, {...data, certificateTypeId: type?.id})
      .then(() => {
        navigate('..')
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
    return
  }

  return (
    <>
      <Content>
        <ManageStructures setParam={setParam} param={param} />
        <RightSide>
          <ParamMainFields param={param} setParam={setParam} />
          {param.structures.map((structure, index) => 
            <StructureContainer key={index}>
              <StructureHeader>
                <Title>{structure.name}</Title>
                {/* <AllowFilesDiv>
                  Permitir arquivos
                  <SwitchBox>
                    <SwitchInput
                      type="checkbox"
                    />
                    <SwitchSlider className="slider"></SwitchSlider>
                  </SwitchBox>
                </AllowFilesDiv> */}
              </StructureHeader>
              {structure.columns.length > 0 && <StructureColumns structureIndex={index} />}
            </StructureContainer>
          )}
        </RightSide>
        <ButtonDiv>
          <Button onClick={() => navigate('..')}>Cancelar</Button>
          <Button onClick={handleCreateOrEditParam} isSave={true}> <img src={saveImage} /> Salvar parâmetro</Button>
        </ButtonDiv>
      </Content>
    </>
  )
}

export default CreateParam